import React, { Component } from 'react';
import axios from 'axios';

import './FullPost.css';

class FullPost extends Component {
	state = {
		loadedPost: null,
	};

	componentDidMount() {
		this.loadData();
	}

	componentDidUpdate() {
		this.loadData();
	}

	loadData = () => {
		if (this.props.match.params.id) {
			if (
				!this.state.loadedPost ||
				(this.state.loadedPost &&
					this.state.loadedPost.id !== +this.props.match.params.id)
			) {
				axios.get('/posts/' + this.props.match.params.id).then(response => {
					this.setState({ loadedPost: response.data });
				});
			}
		}
	};

	render() {
		let post = null;

		if (this.state.loadedPost) {
			post = (
				<div className="Container">
					<div className="FullPost">
						<h1>{this.state.loadedPost.title}</h1>
						<p>{this.state.loadedPost.body}</p>
					</div>
				</div>
			);
		}
		return post;
	}
}

export default FullPost;



// WEBPACK FOOTER //
// ./src/containers/Blog/FullPost/FullPost.js